export const getShouldShowAddCompanySiteOption = (
  companyNames: string[]
): boolean => new Set(companyNames).size === 1;
